import { useHistory } from 'react-router-dom';
import siteTypeFactory from './SiteTypeFactory';

const SiteType = ({ sitesReady, realm, noSiteView }) => {
  const history = useHistory();
  const urlParameters = new URLSearchParams(history.location.search);
  const createSiteType = urlParameters.get('createSite') || 'default';

  return siteTypeFactory({
    realm,
    sitesReady,
    urlParams: urlParameters,
    type: createSiteType.toLowerCase(),
    noSiteView,
  });
};

export default SiteType;
